<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="perfil" titulo="Perfil" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- inicio formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <nav class="level ">
              <!-- Left side -->
              <div class="level-left ">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                      <i class="icon-list-12"></i>
                    </span>
                    <span *ngIf="ctrl.cargando || cargando" class="icon is-medium">
                      <i class="icon-worldwide fa-spin"></i>
                    </span>
                    Perfil v1
                  </p>
                </div>
              </div>

              <div class="level-right">
                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x">
                    <i class="icon-back"> </i>
                  </span>
                  <span class="tooltiptext">Regresar</span>
                </a>



                <a class="navbar-item is-primary tooltip" (click)="ctrl.cargarDatos()" id='cargar_datos'>
                  <span class="icon ">
                    <i class="icon-worldwide fa-2x"></i>
                  </span>
                  <span class="tooltiptext">Actualizar</span>
                </a>

                <button class="button is-primary tooltip" type="submit" [ngClass]="{'is-loading': cargando}" [disabled]="dato.invalid">
                  <span class="icon ">
                    <i class="icon-diskette fa-2x"> </i>
                  </span>
                  <span class="tooltiptext">Guardar</span>
                </button>
              </div>
            </nav>


          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
          <br>
          <span class="tag is-primary is-large ">
            <span class="icon">
              <i class="icon-worldwide fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >

          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('paises', 'paises'); ctrl.cargarCatalogo('grupos', 'sisGrupo'); ctrl.cargarCatalogo('tipos_medios', 'tipo-medio'); "></a>
          <a id="recargar" (click)="ctrl.catalogoDependiente('estados', 'estados', ctrl.dato.get('paises_id').value); ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.get('estados_id').value);"></a>
          <div class="contenedor columns ">
            <div class="column is-one-quarter is-hidden-mobile menu-persona">
              <div>
                <figure class="image is-3by2">
                  <img *ngIf="!ctrl.subir[0]" [src]="ctrl.API_PATH+'/adjunto/usuario/'+ctrl.dato.get('foto').value" alt="Foto" />
                  <img *ngIf="ctrl.subir[0]" [src]="'data:image/jpg;base64,'+ctrl.dato.get('foto').value" alt="Foto" />
                </figure>
                <div align="center">
                  <strong>{{ctrl.dato.get('nombre').value}}</strong>
                  <small>{{ctrl.dato.get('email').value}}</small>
                </div>
                <hr>
                <nav class="panel" *ngIf="ctrl.dato.controls.sis_usuarios_contactos.controls.length > 0">
                  <p class="panel-heading">
                    Contactos
                  </p>
                  <div class="panel-block" *ngFor="let medio of ctrl.dato.controls.sis_usuarios_contactos.controls; let suc = index;">
                    <span class="panel-icon" *ngIf="ctrl.tipos_medios.length > 0">
                      <i [ngClass]="ctrl.tipos_medios[medio.value.tipos_medios_id - 1].icon"></i>
                    </span>
                    {{ medio.value.valor }}
                  </div>
                </nav>

              </div>
            </div>
            <div class="column">

              <div class="tabs is-boxed" style="margin-top: -10px;">

                <!-- se crea los tab se debe definir una variable llamada tab en el .ts con un valor por default ejemplo tab=1 -->
                <ul>
                  <li [ngClass]="{ 'is-active' : tab == 1}">
                    <a (click)="tab=1">
                      <span class="icon">
                        <i class="icon-file"></i>
                      </span>
                      <span>General</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 6}">
                    <a (click)="tab=6">
                      <span class="icon">
                        <i class="icon-padlock"></i>
                      </span>
                      <span>Seguridad</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 2}">
                    <a (click)="tab=2">
                      <span class="icon">
                        <i class="icon-book"></i>
                      </span>
                      <span>Medios de contacto</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 3}">
                    <a (click)="tab=3">
                      <span class="icon">
                        <i class="icon-credit-card-2"></i>
                      </span>
                      <span>RFC</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div [ngClass]="{ 'is-hidden': tab != 1}">

                <div class="field">
                  <label class="label">Nombre:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="nombre"
                      formControlName="nombre">
                    <span class="icon" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                  </p>
                </div>

                <div class="field">
                  <label class="label">Correo eléctronico:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')}"
                      placeholder="Correo eléctronico" formControlName="email">
                    <span class="icon" *ngIf="ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')">Este campo es requerido.</span>
                  </p>
                </div>

                <div class="columns">
                  <div class="column is-4">
                    <label class="label">País:</label>
                    <div class="select">
                      <select class="select" formControlName="paises_id" (change)="ctrl.catalogoDependiente('estados', 'estados', ctrl.dato.controls.paises_id);">
                        <option *ngFor="let item of ctrl.paises" value="{{item.id}}">{{item.nombre}}</option>
                      </select>
                    </div>

                  </div>

                  <div class="column is-4">
                    <label class="label">Estado:</label>
                    <div class="select">
                      <select class="select" formControlName="estados_id" (change)="ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.controls.estados_id);">
                        <option *ngFor="let item of ctrl.estados" value="{{item.id}}">{{item.nombre}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="column is-4">
                    <label class="label">Municipio:</label>
                    <div class="select">
                      <select class="select" formControlName="municipios_id">
                        <option *ngFor="let item of ctrl.municipios" value="{{item.id}}">{{item.nombre}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Direccion:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="direccion" formControlName="direccion">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <div class="field">
                      <label class="label">Num. Exterior:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Num. Exterior" formControlName="numero_exterior">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <div class="field">
                      <label class="label">Num. Interior:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Num. Interior" formControlName="numero_interior">
                      </p>
                    </div>
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Col. / Fracc.:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Col. / Fracc." formControlName="colonia">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <div class="field">
                      <label class="label">Codigo Postal:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="CP" formControlName="codigo_postal">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <br>
                    <br>
                    <div class="field">
                      <div class="b-checkbox is-primary">
                        <input id="spam" class="styled" type="checkbox" formControlName="spam">
                        <label for="spam">
                          Acepta recibir primaryrmación por correo?
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="columns">

                  <div class="column is-4">
                    <div class="field">
                      <label class="label">Ultimo acceso:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('last_login').hasError('required') && ctrl.dato.get('last_login').hasError('required')}"
                          placeholder="Ultimo acceso" formControlName="last_login">
                      </p>
                    </div>
                  </div>

                  <div class="column is-4">
                    <br>
                    <br>
                    <div class="field">
                      <div class="b-checkbox is-primary">
                        <input id="activo" class="styled" type="checkbox" formControlName="activo">
                        <label for="activo">
                          Esta activo?
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Avatar:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Foto" formControlName="avatar">
                  </p>
                </div>

                <div class="field">
                  <label class="label">foto:</label>
                  <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('foto').value == ''">

                    <div class="file has-name">
                      <label class="file-label">
                        <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.foto)" accept="image/x-png,image/gif,image/jpeg,image/jpg">
                        <input foto type="hidden" formControlName="foto">
                        <span class="file-cta">
                          <span class="file-icon">
                            <i class="fa fa-upload"></i>
                          </span>
                          <span class="file-label">
                            Seleccionar archivo
                          </span>
                        </span>

                      </label>
                    </div>
                  </div>

                  <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.foto, 'usuario')" *ngIf="ctrl.dato.get('foto').value != ''">

                    <span class="icon ">
                      <i class="icon-trash"></i>
                    </span>
                    &nbsp; Eliminar la foto

                  </button>

                </div>

              </div>

              <div [ngClass]="{ 'is-hidden': tab != 2}">

                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('sis_usuarios_contactos').length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Medio de contacto</th>
                      <th>Valor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="sis_usuarios_contactos">
                    <tr *ngFor="let medio of ctrl.dato.controls.sis_usuarios_contactos.controls; let suc=index" [formGroupName]="suc">
                      <td>{{ suc + 1 }}</td>
                      <td>
                        <div class="select">
                          <select class="select" name="tipos_medios_id" formControlName="tipos_medios_id">
                            <option *ngFor="let val of ctrl.tipos_medios" value="{{val.id}}">{{ val.nombre }}</option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <p class="control has-icon">
                          <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !ctrl.dato.controls.sis_usuarios_contactos.controls[suc].controls.valor.valid}"
                            type="text">
                          <span class="icon">
                            <i [ngClass]="ctrl.tipos_medios[ctrl.dato.controls.sis_usuarios_contactos.controls[suc].controls.tipos_medios_id.value - 1]?.icon"></i>
                          </span>
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.sis_usuarios_contactos, suc)">
                          <i class="icon-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                  <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.sis_usuarios_contactos, form_sis_usuarios_contactos)">
                    <i class="icon-add2"></i>
                  </button>
                </div>
              </div>

              <div [ngClass]="{ 'is-hidden': tab != 3}">

                <span formArrayName="sis_usuarios_rfcs" *ngIf="ctrl.dato.get('sis_usuarios_rfcs').length > 0">
                  <nav class="panel" *ngFor="let medio of ctrl.dato.controls.sis_usuarios_rfcs.controls; let i=index" [formGroupName]="i">
                    <p class="panel-heading">
                      RFC # {{ i + 1 }}

                      <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.sis_usuarios_rfcs, i)">
                        <i class="icon-trash"></i>
                      </button>
                    </p>
                    <div class="panel-block">
                      <div style="width:100%">
                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Razón Social:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Razón Social" formControlName="razon_social">

                                <span class="help is-danger" *ngIf="!ctrl.dato.controls.sis_usuarios_rfcs.controls[i].controls.razon_social.valid">Este campo es requerido.</span>
                              </p>
                            </div>
                          </div>
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Rfc:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Rfc" formControlName="rfc">

                                <span class="help is-danger" *ngIf="!ctrl.dato.controls.sis_usuarios_rfcs.controls[i].controls.rfc.valid">Este campo es requerido.</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <div class="field">
                                <label class="label">Correo eléctronico:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" placeholder="Correo eléctronico" formControlName="email">

                                </p>
                              </div>
                            </div>
                          </div>

                          <div class="column is-6">
                            <br>
                            <br>
                            <div class="field">
                              <div class="b-checkbox is-primary is-circular">
                                <input id="tipo_persona_f" name="tipo_persona" value="Fisica" class="styled" type="radio" formControlName="tipo_persona">
                                <label for="tipo_persona_f">
                                  Fisica
                                </label>

                                <input id="tipo_persona_m" name="tipo_persona" value="Moral" class="styled" type="radio" formControlName="tipo_persona">
                                <label for="tipo_persona_m">
                                  Moral
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-4">
                            <label class="label">País {{paises_id}}:</label>
                            <div class="select">
                              <select class="select" formControlName="paises_id" (change)="ctrl.catalogoDependiente('estados', 'estados', medio.value.paises_id)">
                                <option *ngFor="let item of ctrl.paises" value="{{item.id}}">{{item.nombre}}</option>
                              </select>
                            </div>

                          </div>

                          <div class="column is-4">
                            <label class="label">Estado:</label>
                            <div class="select">
                              <select class="select" formControlName="estados_id" (change)="ctrl.catalogoDependiente('municipios', 'municipios', medio.value.estados_id)">
                                <option *ngFor="let item of ctrl.estados" value="{{item.id}}">{{item.nombre}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="column is-4">
                            <label class="label">Municipio:</label>
                            <div class="select">
                              <select class="select" formControlName="municipios_id">
                                <option *ngFor="let item of ctrl.municipios" value="{{item.id}}">{{item.nombre}}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Direccion:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="calle" formControlName="calle">
                              </p>
                            </div>
                          </div>

                          <div class="column is-3">
                            <div class="field">
                              <label class="label">Num. Exterior:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Num. Exterior" formControlName="numero_exterior">
                              </p>
                            </div>
                          </div>

                          <div class="column is-3">
                            <div class="field">
                              <label class="label">Num. Interior:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Num. Interior" formControlName="numero_interior">
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Localidad:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Localidad" formControlName="localidad">
                              </p>
                            </div>
                          </div>
                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Col. / Fracc.:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Col. / Fracc." formControlName="colonia">
                              </p>
                            </div>
                          </div>

                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Codigo Postal:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="CP" formControlName="codigo_postal">
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </nav>
                </span>

                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: 20px;">
                  <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.sis_usuarios_rfcs, form_sis_usuarios_rfcs)">
                    <i class="icon-add2"></i>
                  </button>
                </div>
              </div>

              <div [ngClass]="{ 'is-hidden': tab != 6}">

                <br>
                <div class="field">
                  <div class="b-checkbox is-primary">
                    <input id="cambiarPassword" class="styled" type="checkbox" formControlName="cambiarPassword" (click)="toggleCambiarPassword()">
                    <label for="cambiarPassword">
                      Cambiar contraseña
                    </label>
                  </div>
                </div>
                <hr>

                <div class="field">
                  <label class="label">Usuario:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Usuario" formControlName="username">
                  </p>
                </div>

                <div class="field">
                  <label class="label">Contraseña:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="password" placeholder="Contraseña" formControlName="password">
                  </p>
                </div>

                <div class="field">
                  <label class="label">Repetir Contraseña:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="password" placeholder="Repetir Contraseña" formControlName="confirmarPassword">
                  </p>
                </div>
              </div>

            </div>
          </div>

          <!-- fin formulario -->
        </section>


      </form>
    </div>
  </div>
</div>
